import api from 'api'

export const removeMetric = async (id) => {
  const { data } = await api.delete(`/metric/${id}`)

  return data
}
